import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ModuleIconCard from './module-card-icon'
import useSections from 'api/hooks/use-sections'
import { getParentModuleDescription } from './section-descriptions'
import { groupBy } from 'lodash'

function ModulePicker({ setParams, params, limitModules = [] }) {
  const { isSuccess: isSectionsSuccess, data: sections } = useSections({})
  const allSections = isSectionsSuccess ? sections : []

  const sectionsFiltered =
    limitModules.length > 0
      ? allSections.filter((s) => {
          return limitModules.includes(s.abbreviation)
        })
      : allSections

  const groupedSections = isSectionsSuccess && groupBy(sectionsFiltered, 'parent_module')
  const groupedEntries = Object.entries(groupedSections || {})

  return (
    <>
      {groupedEntries.map(([parentModule, childSections]) => {
        const description = getParentModuleDescription(parentModule)

        return (
          <div key={`parent-${parentModule}`} className="mb-4">
            <h6 className="mb-1">{parentModule}</h6>
            {description && (
              <p className="text-muted small mb-3">{description}</p>
            )}
            <Row className="g-3">
              {childSections.map((s) => (
                <Col sm={6} md={4} lg={3} key={`section-card-${s.id}`} className="d-flex">
                  <div className="w-100">
                    <ModuleIconCard
                      section={s}
                      params={params}
                      setParams={setParams}
                    />
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        )
      })}
    </>
  )
}

export default ModulePicker
